//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parseTime } from "@/utils";
export default {
  props: {
    name: String,
    // date: Date,
  },
  computed: {
    // dateText() {
    //   return parseTime(this.date, "{y}年{m}月{d}日");
    // },
  },
  methods: {
    onCityClick() {
      this.$emit("city");
    },
    // onDateClick() {
    //   this.$emit("date");
    // },
  },
};
